<template>
  <div>
    <div class="row-fluid">
      <div class="span5">
        <datepicker :value="date" @input="(val) => (date = val)" />
      </div>
      <div class="span6" v-if="canCreate">
        <button @click="insertConfirmedTherapies" class="btn">
          <fa-icon :icon-name="'fa-rotate'" :no-theme="true" />
          {{ i18nJS.command.generate }}
        </button>
      </div>
    </div>
    <hr />
    <tab-therapies v-if="selected" :guests="sortedGuests" :selected="selected">
      <template slot-scope="guest">
        <guest-tab :guest="guest" />
      </template>
      <guest-confirmed-therapies slot="content" v-if="selected" :guest="selected" :date="date" />
    </tab-therapies>
    <div v-else class="hero-unit center">Non sono state generate le conferme per la giornata di oggi</div>
  </div>
</template>
<script>
import apiConnector from '@/epersonam/apiConnector';
import guestTab from '../guestTab';
import tabTherapies from '../somministration/tabTherapies';
import guestConfirmedTherapies from './guestConfirmedTherapies';
import FaIcon from '../faIcon';
import datepicker from '../datepicker';

export default {
  name: 'confirmedTherapies',
  components: { FaIcon, tabTherapies, guestTab, guestConfirmedTherapies, datepicker },
  props: ['canCreate'],
  data() {
    return {
      guests: [],
      guestConfirmedTherapies: [],
      selected: null,
      date: moment().format('DD/MM/YYYY'),
    };
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
    sortedGuests() {
      const guestsOrdered = [...this.guests];

      return guestsOrdered.sort(this.compare);
    },
  },
  watch: {
    sortedGuests: function () {
      if (!this.selected) this.selected = this.sortedGuests[0];
    },
    date: {
      immediate: true,
      handler: 'loadConfirmedTherapies',
    },
  },
  mounted() {
    this.$on('guestSelected', (guest) => {
      Loader.show();
      this.selected = guest;
    });
  },
  methods: {
    compare(a, b) {
      if (a.full_name < b.full_name) return -1;
      if (a.full_name > b.full_name) return 1;
      return 0;
    },
    loadConfirmedTherapies() {
      Loader.show();
      let newDate = moment(this.date, this.i18nJS.time.formats.date_only).format('YYYY-MM-DD');
      apiConnector()
        .get('/it/confirmed_therapies/guest_period_data_sets/' + newDate + '.json')
        .then(({ data }) => {
          this.guests = data;
          if (this.sortedGuest) this.selected = this.sortedGuest[0];
          Loader.hide();
        })
        .catch((err) => {
          alert('errore');
          Loader.hide();
        });
    },
    insertConfirmedTherapies() {
      Loader.show();
      let newDate = moment(this.date, this.i18nJS.time.formats.date_only).format('YYYY-MM-DD');
      apiConnector()
        .get('/it/confirmed_therapies/insert/' + newDate + '.json')
        .then(({ data }) => {
          alert('Sono state create ' + data.ids.length + ' nuove terapie da confermare');
          this.loadConfirmedTherapies();
        })
        .catch((err) => {
          alert('errore');
          Loader.hide();
        });
    },
  },
};
</script>
<style lang="scss" scoped></style>
